import React, { Component  } from 'react';
import withRouter from "../../Utils/withRouter";
import axios from "axios";
import Swal from "sweetalert2";
import { ConfigContext } from "../../Context/ConfigContext";
import { IsRequired, SubmitButton } from '../../Components/InputElements';
import Select from "react-select";

const indianStates = [
  { value: "AP", label: "Andhra Pradesh",  },
  { value: "AR", label: "Arunachal Pradesh",  },
  { value: "AS", label: "Assam",  },
  { value: "BR", label: "Bihar",  },
  { value: "CG", label: "Chhattisgarh",  },
  { value: "GA", label: "Goa",  },
  { value: "GJ", label: "Gujarat",  },
  { value: "HR", label: "Haryana",  },
  { value: "HP", label: "Himachal Pradesh",  },
  { value: "JH", label: "Jharkhand",  },
  { value: "KA", label: "Karnataka",  },
  { value: "KL", label: "Kerala",  },
  { value: "MP", label: "Madhya Pradesh",  },
  { value: "MH", label: "Maharashtra",  },
  { value: "MN", label: "Manipur",  },
  { value: "ML", label: "Meghalaya",  },
  { value: "MZ", label: "Mizoram",  },
  { value: "NL", label: "Nagaland",  },
  { value: "OD", label: "Odisha",  },
  { value: "PB", label: "Punjab",  },
  { value: "RJ", label: "Rajasthan",  },
  { value: "SK", label: "Sikkim",  },
  { value: "TN", label: "Tamil Nadu",  },
  { value: "TG", label: "Telangana",  },
  { value: "TR", label: "Tripura",  },
  { value: "UP", label: "Uttar Pradesh",  },
  { value: "UK", label: "Uttarakhand",  },
  { value: "WB", label: "West Bengal",  },
  { value: "AN", label: "Andaman and Nicobar Islands",  },
  { value: "CH", label: "Chandigarh",  },
  { value: "DN", label: "Dadra and Nagar Haveli",  },
  { value: "DD", label: "Daman and Diu",  },
  { value: "DL", label: "Delhi",  },
  { value: "JK", label: "Jammu and Kashmir",  },
  { value: "LA", label: "Ladakh",  },
  { value: "LD", label: "Lakshadweep",  },
  { value: "PY", label: "Puducherry",  }
];

class CreateCompany extends Component {
  static contextType = ConfigContext;
  constructor(props) {
    super(props);
    this.state = {
      postLoading: false,
      responseModal: false,
      company_id: 0,
      company_code: "",
      legal_entity_name: "",
      company_name: "",
      contact_person: "",
      contact_person_email: "",
      main_office_address: "",
      company_city: "",
      company_state: "",
      company_pincode: "",
      company_country: "",
      company_website: "",
      registration_number: "",
      company_industry_type: "",
      date_of_incorporation: "",
      number_of_employees: "",
      nature_of_business: "",
      type_of_company: "",

      
      parent_company_name: "",
      subsidiary_company_name: "",
      parent_legal_entity_name: "",
      subsidiary_legal_entity_name: "",
      contact_person_mobile: "",
      
      company_address: "",
      service_offer: "ABStart",
      register_office_location: "",
      
      
      
      
      contract_start_date: "",
      contract_end_date: "",
      
      
      have_parent_company: "",
      have_subsidiary_company: "",
      total_employees: "",
     
      twitter_handler: "",
      pt_applicable: 0,
      lwf_applicable: 0,
      company_logo: null,
      company_logo_url: null,
      errors: {},
      responseList:[]
    };
    this.closeRef = React.createRef();
    this.company_code_ref = React.createRef();
    this.legal_entity_name_ref = React.createRef();
    this.company_name_ref = React.createRef();
    this.contact_person_ref = React.createRef();
    this.contact_person_email_ref = React.createRef();
    this.main_office_address_ref = React.createRef();
    this.company_city_ref = React.createRef();
    this.company_state_ref = React.createRef();
    this.company_pincode_ref = React.createRef();
    this.company_country_ref = React.createRef();
    this.company_industry_type_ref = React.createRef();
    this.date_of_incorporation_ref = React.createRef();
    this.number_of_employees_ref = React.createRef();
    this.nature_of_business_ref = React.createRef();
    this.type_of_company_ref = React.createRef();
  }

  componentDidMount() {
    const queryParams = new URLSearchParams(window.location.search);
    const id = queryParams.get('id');
    // console.log("this.props?.company_id",id);
    if (id !== 0 && id) {
      this.setState({ loadingList: true, company_id: id },
        ()=>{ this.GetInfo() }
      );
    } else {
      this.resetForm();
    }
  }

  handleErrorAutoScroll=()=>{
    // console.log("this.state.errors.company_code && this.company_code_ref.current",this.state.errors.company_code && this.company_code_ref.current);
    if (this.state.errors.company_code && this.company_code_ref.current) {
        this.company_code_ref.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
        this.company_code_ref.current.focus();
    }
    if (this.state.errors.legal_entity_name && this.legal_entity_name_ref.current) {
        this.legal_entity_name_ref.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
        this.legal_entity_name_ref.current.focus();
    }
    if (this.state.errors.company_name && this.company_name_ref.current) {
        this.company_name_ref.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
        this.company_name_ref.current.focus();
    }
    if (this.state.errors.contact_person && this.contact_person_ref.current) {
        this.contact_person_ref.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
        this.contact_person_ref.current.focus();
    }
    if (this.state.errors.contact_person_email && this.contact_person_email_ref.current) {
        this.contact_person_email_ref.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
        this.contact_person_email_ref.current.focus();
    }
    if (this.state.errors.main_office_address && this.main_office_address_ref.current) {
        this.main_office_address_ref.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
        this.main_office_address_ref.current.focus();
    }
    if (this.state.errors.company_city && this.company_city_ref.current) {
        this.company_city_ref.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
        this.company_city_ref.current.focus();
    }
    if (this.state.errors.company_state && this.company_state_ref.current) {
      this.company_state_ref.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
      this.company_state_ref.current.focus();
    }
    if (this.state.errors.company_pincode && this.company_pincode_ref.current) {
      this.company_pincode_ref.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
      this.company_pincode_ref.current.focus();
    }
    if (this.state.errors.company_country && this.company_country_ref.current) {
      this.company_country_ref.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
      this.company_country_ref.current.focus();
    }
    if (this.state.errors.company_industry_type && this.company_industry_type_ref.current) {
      this.company_industry_type_ref.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
      this.company_industry_type_ref.current.focus();
    }
    if (this.state.errors.date_of_incorporation && this.date_of_incorporation_ref.current) {
      this.date_of_incorporation_ref.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
      this.date_of_incorporation_ref.current.focus();
    }
    if (this.state.errors.number_of_employees && this.number_of_employees_ref.current) {
      this.number_of_employees_ref.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
      this.number_of_employees_ref.current.focus();
    }
    if (this.state.errors.type_of_company && this.type_of_company_ref.current) {
      this.type_of_company_ref.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
      this.type_of_company_ref.current.focus();
    }
  }


  GetInfo = () => {
    const { apiURL, apiHeaderJson } = this.context;
    const headers = apiHeaderJson;
    axios.get(`${apiURL}Companies/GetCompanyInfo?company_id=${this.state.company_id}`, { headers }).then((response) => {
      const { data, success } = response.data;
      if (success === true && data.length > 0) {
        this.setState(
          {
            company_code: data[0].company_code,
            legal_entity_name: data[0].legal_entity_name,
            company_name: data[0].company_name,
            contact_person: data[0].contact_person,
            contact_person_email: data[0].email_address,
            main_office_address: data[0].registered_office_address,
            company_city: data[0].company_city,
            company_state: data[0].company_state,
            company_pincode: data[0].pin_code,
            company_country: data[0].company_country,
            company_website: data[0].company_website,
            registration_number: data[0].registration_number,
            company_industry_type: data[0].company_industry_type,
            date_of_incorporation : data[0].date_of_establishment,
            number_of_employees : data[0].total_employees,
            nature_of_business: data[0].nature_of_business,
            type_of_company: data[0].type_of_company,


            company_logo: data[0].company_logo,
            company_logo_url: data[0].company_logo_url,
            parent_legal_entity_name: data[0].parent_legal_entity_name,
            subsidiary_legal_entity_name: data[0].subsidiary_legal_entity_name,
            parent_company_name: data[0].parent_company_name,
            subsidiary_company_name: data[0].subsidiary_company_name,
            contact_person_mobile: data[0].mobile_number,
            company_address: data[0].company_address,
            service_offer: data[0].service_offer,
            register_office_location: data[0].registered_office_location,
            
            
            
            
            contract_start_date: data[0].contract_start_date,
            contract_end_date: data[0].contract_end_date,
            
            have_parent_company: data[0].have_parent_company,
            have_subsidiary_company: data[0].have_subsidiary_company,
            
            total_employees: `${data[0].total_employees}`,
            
            state: data[0].company_state,
            
            
            twitter_handler: data[0].twitter_handle,
            pt_applicable: data[0].is_pt_applicable,
            lwf_applicable: data[0].is_lwf_applicable,
          }
        )
      }
    });
  }


  handleSubmit = (e) => {
    e.preventDefault();
    const errors = this.validateForm();

    if (Object.keys(errors).length > 0) {
      console.log("errors", errors);
      this.setState({ errors,postLoading:false },
        ()=>{ this.handleErrorAutoScroll()});
      return;
    }

    const { apiURL, apiHeaderFile } = this.context;
    const headers = apiHeaderFile;

    this.setState({ postLoading: true, });
    const formData = {
      company_id: this.state.company_id || null,
      company_code: this.state.company_code,
      legal_entity_name: this.state.legal_entity_name,
      company_name: this.state.company_name,
      contact_person: this.state.contact_person,
      email_address: this.state.contact_person_email,
      registered_office_address: this.state.main_office_address,
      company_city: this.state.company_city,
      company_state: this.state.company_state,
      pin_code: this.state.company_pincode,
      company_country: this.state.company_country,
      company_website: this.state.company_website,
      registration_number: this.state.registration_number,
      company_industry_type: this.state.company_industry_type,
      date_of_establishment: this.state.date_of_incorporation,
      total_employees: this.state.number_of_employees,
      nature_of_business: this.state.nature_of_business,
      type_of_company: this.state.type_of_company,
      parent_company_name: this.state.parent_company_name,
      subsidiary_company_name: this.state.subsidiary_company_name,
      parent_legal_entity_name: this.state.parent_legal_entity_name,
      subsidiary_legal_entity_name: this.state.subsidiary_legal_entity_name,
      mobile_number: this.state.contact_person_mobile,
      company_address: this.state.company_address,
      service_offer: this.state.service_offer,
      registered_office_location: this.state.register_office_location,
      // contract_start_date: this.state.contract_start_date,
      contract_end_date: this.state.contract_end_date,
      have_parent_company: this.state.have_parent_company,
      have_subsidiary_company: this.state.have_parent_company,    
      twitter_handle: this.state.twitter_handler,
      is_pt_applicable: this.state.pt_applicable,
      is_lwf_applicable: this.state.lwf_applicable,
      company_logo: this.state.company_logo,
    }

    Swal.fire({
      title: "Are you sure?",
      text: `You want you to create company!`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, Create!",
      allowOutsideClick: false,
    }).then((result) => {
      if (result.isConfirmed) {
      Swal.fire({
        title: 'Please wait...',
        text: 'Processing your request',
        icon: 'info',
        allowOutsideClick: false,
        showConfirmButton: false,
        willOpen: () => {
          Swal.showLoading()
        }
      })
      axios.post(`${apiURL}Companies/CreateCompany`, formData, { headers })
      .then((response) => {
       
        const { success,company_setup_results } = response.data;
        if (success === true) {
          this.resetForm();
          setTimeout(() => {
            if (this.props.params.company_id) {
              this.closeRef.current.click();
            }
          }, 1000);
          this.setState({ postLoading: false, });
          this.GetInfo();
          Swal.fire({
            title: `<strong>${response.data.success === true ? 'Success' : 'Failed'}</strong>`,
            text: response.data.message,
            icon: response.data.success === true ? 'success' : 'error',
            showConfirmButton: true,
            allowOutsideClick: false,
          }).then(() => {
            // Perform the state update here
            if(Array.isArray(company_setup_results) && company_setup_results?.length>0){
              this.setState({
                responseModal: true,
                responseList:company_setup_results,
              });
            }
          });
          
        } else {
          this.setState({ postLoading: false });
          Swal.fire({
            title: `<strong>${response.data.success === true ? 'Success' : 'Failed'}</strong>`,
            text: response.data.message,
            icon: response.data.success === true ? 'success' : 'error',
            showConfirmButton: true,  
            allowOutsideClick: false,
          });
        }
        Swal.close()
      }).catch((error)=>{
        Swal.close();
        Swal.fire({
          title: `<strong>${'Failed'}</strong>`,
          text: `Opps..! Something went wrong.`,
          icon: 'error',
          showConfirmButton: true, 
          allowOutsideClick: false,
        });
      }).finally(()=>{
        Swal.close();
        this.setState({ postLoading: false });
      });
    }});
  };

  resetForm = () => {
    this.setState({
      postLoading: false,
      company_code: "",
      legal_entity_name: "",
      company_name: "",
      contact_person: "",
      contact_person_email: "",
      main_office_address: "",
      company_city: "",
      company_state: "",
      company_pincode: "",
      company_country: "",
      company_website: "",
      registration_number: "",
      company_industry_type: "",
      date_of_incorporation: "",
      number_of_employees: "",
      nature_of_business: "",
      type_of_company: "",

      
      parent_company_name: "",
      subsidiary_company_name: "",
      parent_legal_entity_name: "",
      subsidiary_legal_entity_name: "",
      contact_person_mobile: "",
      company_address: "",
      service_offer: "ABStart",
      register_office_location: "",
      
      
      
      
      // contract_start_date: "",
      contract_end_date: "",
      
      have_parent_company: "",
      have_subsidiary_company: "",
      
      total_employees: "",      
      state: "",
      
      twitter_handler: "",
      pt_applicable: 0,
      lwf_applicable: 0,
      company_logo: null,
      errors: {}
    });
  };


  handleCheckboxChange = (e) => {
    const { name, checked } = e.target;
    this.setState({
      [name]: checked ? 1 : 0
    });
  };
  handleSelectChange = (name, value) => {
    console.log(value);
    this.setState({
      [name]: value
    });
  };

  // handleInputChange = (e) => {
  //   const { name, value } = e.target;
  //   this.setState((prevState) => ({
  //     [name]: value,
  //     errors: {
  //       ...prevState.errors,
  //       [name]: '',
  //     },
  //   }));
  // };

  handleInputChange = (e) => {
    const { name, value, type } = e.target;
    const newValue = type === 'file' ? e.target.files[0] : value;
    this.setState((prevState) => ({
      [name]: newValue,
      errors: {
        ...prevState.errors,
        [name]: '',
      },
    }));
  };
  handleChange = (name, value) => {
    console.log(name, value);
    this.setState((prevState) => ({
      [name]: value,
      errors: {
        ...prevState.errors,
        [name]: '',
      },
    }));
}
  ViewLogo = () => {
    Swal.fire({
      title: 'Company Logo',
      html: `<img src='${this.state.company_logo_url}' style="max-width: 100%;" />`,
      showCloseButton: true,
      showCancelButton: false,
      showConfirmButton: false,
    });
  };

  validateForm = () => {
    const errors = {};

    if (!this.state.company_code) {
      errors.company_code = 'Company Code is required';
      return errors;
    }
    if (!this.state.legal_entity_name) {
      errors.legal_entity_name = 'Legal Entity Name is required';
      return errors;
    }
    if (!this.state.company_name) {
      errors.company_name = 'Company Name is required';
      return errors;
    }
    if (!this.state.contact_person) {
      errors.contact_person = 'Contact Person is required';
      return errors;
    }
    if (!this.state.contact_person_email) {
      errors.contact_person_email = 'Contact Person Email is required';
    } else if (!/\S+@\S+\.\S+/.test(this.state.contact_person_email)) {
      errors.contact_person_email = 'Contact Person Email is invalid';
    }
    if (!this.state.main_office_address) {
      errors.main_office_address = 'Register office address is required';
    }
    if (!this.state.company_city) {
      errors.company_city = 'City is required';
    }
    if (!this.state.company_state) {
      errors.company_state = 'State is required';
    }
    if (!this.state.company_pincode) {
      errors.company_pincode = 'Pincode is required';
    }
    if (!this.state.company_country) {
      errors.company_country = 'Country is required';
    }
    if (!this.state.company_industry_type) {
      errors.company_industry_type = 'Type of Company is required';
    }
    if (!this.state.date_of_incorporation) {
      errors.date_of_incorporation = 'Date Of Incorporation is required';
    }
    if (!this.state.number_of_employees) {
      errors.number_of_employees = 'Number Of Employees is required';
    }
    if (!this.state.nature_of_business) {
      errors.nature_of_business = 'Nature Of Business is required';
    }
    if (!this.state.type_of_company) {
      errors.type_of_company = 'This is required';
    }



    
    // if (!this.state.company_logo) {
    //   errors.company_logo = 'company logo is required';
    // }
    if (this.state.company_logo && this.state.company_logo.size > 10 * 1024 * 1024) {
      errors.company_logo = 'File size exceeds the maximum limit of 10MB';
    }
    // if (!this.state.contact_person_mobile) {
    //   errors.contact_person_mobile = 'Mobile No. is required';
    // }
    // if (!this.state.company_address) {
    //   errors.company_address = 'Comapany address is required';
    // }

    if (!this.state.service_offer) {
      errors.service_offer = 'Service Offer is required';
    }

    

    // if (!this.state.register_office_location) {
    //   errors.register_office_location = 'Register Office Location is required';
    // }

    // if (!this.state.registration_number) {
    //   errors.registration_number = 'Registration Number is required';
    // }

    

    
    

    // if (!this.state.contract_start_date) {
    //   errors.contract_start_date = 'Contract Start Date is required';
    // }

    // if (!this.state.contract_end_date) {
    //   errors.contract_end_date = 'Contract End Date is required';
    // }

    

    // if (!this.state.total_employees) {
    //   errors.total_employees = 'Total Employees is required';
    // }

    
    

    if (this.state.have_parent_company==="1" && !this.state.parent_legal_entity_name) {
      errors.parent_legal_entity_name = 'Legal Entity Name is required';
    }
    
    if (this.state.have_parent_company==="1" && !this.state.parent_company_name) {
      errors.parent_company_name = 'Legal Entity Name is required';
    }
    if (this.state.have_subsidiary_company==="1" && !this.state.subsidiary_legal_entity_name) {
      errors.subsidiary_legal_entity_name = 'Legal Entity Name is required';
    }
    if (this.state.have_subsidiary_company==="1" && !this.state.subsidiary_company_name) {
      errors.subsidiary_company_name = 'Legal Entity Name is required';
    }

    

    // if (!this.state.twitter_handler) {
    //   errors.twitter_handler = 'Twitter Handler is required';
    // }

    return errors;
  };

  render() {
    const { errors } = this.state;

    return (
      // <div className="main-content">
          <div className=""> 
            {/* <br /> */}
            {/* <PageTitle title={`Company Onboard`} primary={`Home`} /> */}
            {/* <div className="row">
              <div className="col-md-12">
                <div className="card-body"> */}
                  {/* <div className="card-header align-items-center d-flex">
                      <h4 className="card-title mb-0 flex-grow-1">
                          {this.props.params.company_id? "Update Company":"Create Company"}
                      </h4>
                      <NavLink className="btn btn-success btn-sm" 
                        to={`/CompanyList`}>
                          <i className="bx ri-arrow-left-circle-line label-icon align-middle fs-4 " />
                      </NavLink>
                  </div> */}
                  <div className="container mt-2">
                    <form>
                      <div className="row">
                        {/* <div className="row mb-3"> */}
                          {/* Company Code */}
                          <div ref={this.company_code_ref} className="col-md-4 mb-3">
                            <label htmlFor="company_code" className="form-label">Company Code <IsRequired />:</label>
                            <input
                              type="text"
                              id="company_code"
                              name="company_code"
                              value={this.state.company_code}
                              onChange={this.handleInputChange}
                              className={`form-control ${errors.company_code ? 'is-invalid' : ''}`}
                              placeholder="Enter Code"
                            />
                            {errors.company_code && <div className="invalid-feedback">{errors.company_code}</div>}
                          </div>
                          {/* Legal Entity Name  */}
                          <div ref={this.legal_entity_name_ref} className="col-md-4 mb-3">
                            <label htmlFor="legal_entity_name" className="form-label">Legal Entity Name <IsRequired /> :</label>
                            <input
                              type="text"
                              id="legal_entity_name"
                              name="legal_entity_name"
                              value={this.state.legal_entity_name}
                              onChange={this.handleInputChange}
                              className={`form-control ${errors.legal_entity_name ? 'is-invalid' : ''}`}
                              placeholder="Enter Name"
                            />
                            {errors.legal_entity_name && <div className="invalid-feedback">{errors.legal_entity_name}</div>}
                          </div>
                          {/* Company Logo  */}
                          <div className="col-md-4 mb-3">
                            <label htmlFor="company_logo" className="form-label">Company Logo 
                              {/* <IsRequired /> */}
                              :</label>
                            <a href={`${this.state.company_logo_url}`}
                              className={`${!this.state.company_logo_url ? ('d-none') : ''} link-info link-offset-2 link-underline-opacity-100-hover`}
                              style={{ float: 'right' }}
                              target="_blank" rel="noopener noreferrer">
                              View Logo
                              <i className="ri-arrow-right-line label-icon align-middle fs-16" />
                            </a>
                            <input
                              type="file"
                              id="company_logo"
                              name="company_logo"
                              accept=".jpg, .png, .jpeg"
                              onChange={this.handleInputChange}
                              className={`form-control ${errors.company_logo ? 'is-invalid' : ''}`}
                            />
                            {errors.company_logo && <div className="invalid-feedback">{errors.company_logo}</div>}
                            {/* </div> */}
                          </div>
                          {/* Company Name */}
                          <div ref={this.company_name_ref} className="col-md-4 mb-3">
                            <label htmlFor="company_name" className="form-label">Company Name <IsRequired /> :</label>
                            <input
                              type="text"
                              id="company_name"
                              name="company_name"
                              value={this.state.company_name}
                              onChange={this.handleInputChange}
                              className={`form-control ${errors.company_name ? 'is-invalid' : ''}`}
                              placeholder="Enter Name"
                            />
                            {errors.company_name && <div className="invalid-feedback">{errors.company_name}</div>}
                          </div>
                          {/* Contact Person Name */}
                          <div ref={this.contact_person_ref} className="col-md-4 mb-3">
                            <label htmlFor="contact_person" className="form-label">Contact Person Name <IsRequired /> :</label>
                            <input
                              type="text"
                              id="contact_person"
                              name="contact_person"
                              value={this.state.contact_person}
                              onChange={this.handleInputChange}
                              className={`form-control ${errors.contact_person ? 'is-invalid' : ''}`}
                              placeholder="Enter Contact"
                            />
                            {errors.contact_person && <div className="invalid-feedback">{errors.contact_person}</div>}
                          </div>
                          {/* Contact Person Email */}
                          <div ref={this.contact_person_email_ref} className="col-md-4 mb-3">
                            <label htmlFor="contact_person_email" className="form-label">Contact Person Email <IsRequired /> :</label>
                            <input
                              type="contact_person_email"
                              id="contact_person_email"
                              name="contact_person_email"
                              value={this.state.contact_person_email}
                              onChange={this.handleInputChange}
                              className={`form-control ${errors.contact_person_email ? 'is-invalid' : ''}`}
                              placeholder="Enter Email"
                            />
                            {errors.contact_person_email && <div className="invalid-feedback">{errors.contact_person_email}</div>}
                          </div>
                        {/* </div> */}
                        {/* <div className="row mb-3"> */}
                          {/* Main Office Address */}
                          <div ref={this.main_office_address_ref} className="col-md-4 mb-3">
                            <label htmlFor="main_office_address" className="form-label">Main Office Address <IsRequired /> :</label>
                            <textarea
                              id="main_office_address"
                              name="main_office_address"
                              value={this.state.main_office_address}
                              onChange={this.handleInputChange}
                              className={`form-control ${errors.main_office_address ? 'is-invalid' : ''}`}
                              placeholder="Enter Address"
                            />
                            {errors.main_office_address && <div className="invalid-feedback">{errors.main_office_address}</div>}
                          </div>
                           {/* City */}
                           <div ref={this.company_city_ref} className="col-md-4 mb-3">
                            <label htmlFor="company_city" className="form-label">City <IsRequired />:</label>
                            <input
                              type="text"
                              id="company_city"
                              name="company_city"
                              value={this.state.company_city}
                              onChange={this.handleInputChange}
                              className={`form-control ${errors.company_city ? 'is-invalid' : ''}`}
                              placeholder="Enter City"
                            />
                            {errors.company_city && <div className="invalid-feedback">{errors.company_city}</div>}
                          </div>
                          {/* State */}
                          <div ref={this.company_state_ref} className="col-md-4 mb-3">
                            <label htmlFor="company_state" className="form-label">State <IsRequired />:</label>
                            <Select 
                            id="company_state"
                            name="company_state"
                            value={this.state.company_state ? indianStates.find((option) => option.value === this.state.company_state) : null}
                            onChange={(selectedOption) => this.handleSelectChange("company_state", selectedOption.value)}
                            options={indianStates}
                            placeholder="Select State"
                            />
                            {errors.company_state && <div className="text-danger">{errors.company_state}</div>}
                          </div>
                          {/* Pin-code */}
                          <div ref={this.company_pincode_ref} className="col-md-4 mb-3">
                            <label htmlFor="company_pincode" className="form-label">Pin-code <IsRequired /> :</label>
                            <input
                              type="text"
                              id="company_pincode"
                              name="company_pincode"
                              value={this.state.company_pincode}
                              onChange={this.handleInputChange}
                              className={`form-control ${errors.company_pincode ? 'is-invalid' : ''}`}
                              placeholder="Enter company_Pincode"
                            />
                            {errors.company_pincode && <div className="invalid-feedback">{errors.company_pincode}</div>}
                          </div>
                          {/* Country */}
                          <div ref={this.company_country_ref} className="col-md-4 mb-3">
                            <label htmlFor="company_country" className="form-label">Country <IsRequired /> :</label>
                            <input
                              type="text"
                              id="company_country"
                              name="company_country"
                              value={this.state.company_country}
                              onChange={this.handleInputChange}
                              className={`form-control ${errors.company_country ? 'is-invalid' : ''}`}
                              placeholder="Enter company_Country"
                            />
                            {errors.company_country && <div className="invalid-feedback">{errors.company_country}</div>}
                          </div>
                          {/* Website */}
                          <div className="col-md-4 mb-3">
                            <label htmlFor="company_website" className="form-label">Website:</label>
                            <input
                              type="text"
                              id="company_website"
                              name="company_website"
                              value={this.state.company_website}
                              onChange={this.handleInputChange}
                              className={`form-control ${errors.company_website ? 'is-invalid' : ''}`}
                              placeholder="Enter Website"
                            />
                            {/* {errors.company_website && <div className="invalid-feedback">{errors.company_website}</div>} */}
                          </div>
                          {/* Registration Number */}
                          <div className="col-md-4 mb-3">
                            <label htmlFor="registration_number" className="form-label">Registration Number:</label>
                            <input
                              type="text"
                              id="registration_number"
                              name="registration_number"
                              value={this.state.registration_number}
                              onChange={this.handleInputChange}
                              className={`form-control ${errors.registration_number ? 'is-invalid' : ''}`}
                              placeholder="Enter Registration Number"
                            />
                            {/* {errors.registration_number && <div className="invalid-feedback">{errors.registration_number}</div>} */}
                          </div>
                          {/* Industry Type */}
                          <div ref={this.company_industry_type_ref} className="col-md-4 mb-3">
                            <label htmlFor="company_industry_type" className="form-label">Industry Type <IsRequired /> :</label>
                            <input
                              type="text"
                              id="company_industry_type"
                              name="company_industry_type"
                              value={this.state.company_industry_type}
                              onChange={this.handleInputChange}
                              className={`form-control ${errors.company_industry_type ? 'is-invalid' : ''}`}
                              placeholder="Enter Industry Type"
                            />
                            {errors.company_industry_type && <div className="invalid-feedback">{errors.company_industry_type}</div>}
                          </div>
                          {/* Date of Incorporation */}
                          <div ref={this.date_of_incorporation_ref} className="col-md-4 mb-3">
                            <label htmlFor="date_of_incorporation" className="form-label">Date of Incorporation <IsRequired /> :</label>
                            <input
                              type="date"
                              id="date_of_incorporation"
                              name="date_of_incorporation"
                              value={this.state.date_of_incorporation}
                              onChange={this.handleInputChange}
                              className={`form-control ${errors.date_of_incorporation ? 'is-invalid' : ''}`}
                            />
                            {errors.date_of_incorporation && <div className="invalid-feedback">{errors.date_of_incorporation}</div>}
                          </div>
                          {/* Number of Employees */}
                          <div ref={this.number_of_employees_ref} className="col-md-4 mb-3">
                            <label htmlFor="number_of_employees" className="form-label">Number of Employees <IsRequired /> :</label>
                            <input
                              type="number"
                              id="number_of_employees"
                              name="number_of_employees"
                              value={this.state.number_of_employees}
                              onChange={this.handleInputChange}
                              className={`form-control ${errors.number_of_employees ? 'is-invalid' : ''}`}
                              placeholder="Enter Contact"
                            />
                            {errors.number_of_employees && <div className="invalid-feedback">{errors.number_of_employees}</div>}
                          </div>
                          {/* Nature Of Business */}
                          <div ref={this.nature_of_business_ref} className="col-md-4 mb-3">
                            <label htmlFor="nature_of_business" className="form-label">Nature Of Business <IsRequired /> :</label>
                            <input
                              type="text"
                              id="nature_of_business"
                              name="nature_of_business"
                              value={this.state.nature_of_business}
                              onChange={this.handleInputChange}
                              className={`form-control ${errors.nature_of_business ? 'is-invalid' : ''}`}
                              placeholder="Enter Nature Of Business"
                            />
                            {errors.nature_of_business && <div className="invalid-feedback">{errors.nature_of_business}</div>}
                          </div>
                          {/* Company Type */}
                          <div ref={this.type_of_company_ref} className="col-md-4 mb-3">
                            <label htmlFor="type_of_company" className="form-label">Company Type <IsRequired /> :</label>
                            <input
                              type="text"
                              id="type_of_company"
                              name="type_of_company"
                              value={this.state.type_of_company}
                              onChange={this.handleInputChange}
                              className={`form-control ${errors.type_of_company ? 'is-invalid' : ''}`}
                              placeholder="Enter Type of Company"
                            />
                            {errors.type_of_company && <div className="invalid-feedback">{errors.type_of_company}</div>}
                          </div>
                          {/* Service Offer */}
                          <div className="col-md-4 mb-3">
                            <label className="form-label">Service Offer:</label>
                            <div>
                              {/* <label htmlFor="service_offer_abstart" className="form-check-label" style={{ marginRight: "5px" }}>ABStart </label>
                              <input
                                type="radio"
                                id="service_offer_abstart"
                                name="service_offer"
                                value="ABStart"
                                checked={this.state.service_offer === "ABStart"}
                                onChange={this.handleInputChange}
                                className="form-check-input"
                              /> */}

                              <label htmlFor="service_offer_staffing" style={{ marginRight: "5px" }} className="form-check-label">Staffing </label>
                              <input
                                type="radio"
                                id="service_offer_staffing"
                                name="service_offer"
                                value="Staffing"
                                checked={this.state.service_offer === "Staffing"}
                                onChange={this.handleInputChange}
                                className="form-check-input"
                              />
                              <label htmlFor="service_offer_saas" style={{ marginLeft: "20px", marginRight: "5px" }} className="form-check-label">SAAS </label>
                              <input
                                type="radio"
                                id="service_offer_saas"
                                name="service_offer"
                                value="SAAS"
                                checked={this.state.service_offer === "SAAS"}
                                onChange={this.handleInputChange}
                                className="form-check-input"
                              />
                            </div>
                            {errors.service_offer && <div className="invalid-feedback d-block">{errors.service_offer}</div>}
                          </div>
                          {/* Do You have Parent Company? */}
                          <div className="col-md-4">
                            <div>
                                <label>Do You have Parent Company?</label>
                            </div>
                            <div className="form-check form-check-inline">
                                <input
                                    type="radio"
                                    id="have_parent_company_yes"
                                    name="have_parent_company"
                                    value="1"
                                    checked={this.state.have_parent_company === "1"}
                                    onChange={() => this.handleChange("have_parent_company","1") }
                                    className="form-check-input"
                                />
                                <label
                                    htmlFor="have_parent_company_yes"
                                    className="form-check-label"
                                >
                                    Yes
                                </label>
                            </div>
                            <div className="form-check form-check-inline">
                                <input
                                    type="radio"
                                    id="have_parent_company_no"
                                    name="have_parent_company"
                                    value="0"
                                    checked={this.state.have_parent_company === "0"}
                                    onChange={() => this.handleChange("have_parent_company","0") }
                                    className="form-check-input"
                                />
                                <label
                                    htmlFor="have_parent_company_no"
                                    className="form-check-label"
                                >
                                    No
                                </label>
                            </div>
                          </div>
                          {this.state.have_parent_company === "1" && (
                            <>
                              {/* Parent Legal Entity Name  */}
                              <div className="col-md-4 mb-3">
                                <label htmlFor="parent_legal_entity_name" className="form-label">Parent Legal Entity Name <IsRequired /> :</label>
                                <input
                                  type="text"
                                  id="parent_legal_entity_name"
                                  name="parent_legal_entity_name"
                                  value={this.state.parent_legal_entity_name}
                                  onChange={this.handleInputChange}
                                  className={`form-control ${errors.parent_legal_entity_name ? 'is-invalid' : ''}`}
                                  placeholder="Enter Name"
                                />
                                {errors.parent_legal_entity_name && <div className="invalid-feedback">{errors.parent_legal_entity_name}</div>}
                              </div>
                              {/* Parent Company Name */}
                              <div className="col-md-4 mb-3">
                                <label htmlFor="parent_company_name" className="form-label">Parent Company Name <IsRequired /> :</label>
                                <input
                                  type="text"
                                  id="parent_company_name"
                                  name="parent_company_name"
                                  value={this.state.parent_company_name}
                                  onChange={this.handleInputChange}
                                  className={`form-control ${errors.parent_company_name ? 'is-invalid' : ''}`}
                                  placeholder="Enter Name"
                                />
                                {errors.parent_company_name && <div className="invalid-feedback">{errors.parent_company_name}</div>}
                              </div>
                            </>
                          )}
                          {/* Do You have Subsidiary Company? */}
                          <div className="col-md-4">
                            <div>
                                <label>Do You have Subsidiary Company?</label>
                            </div>
                            <div className="form-check form-check-inline">
                                <input
                                    type="radio"
                                    id="have_subsidiary_company_yes"
                                    name="have_subsidiary_company"
                                    value="1"
                                    checked={this.state.have_subsidiary_company === "1"}
                                    onChange={() => this.handleChange("have_subsidiary_company","1") }
                                    className="form-check-input"
                                />
                                <label
                                    htmlFor="have_subsidiary_company_yes"
                                    className="form-check-label"
                                >
                                    Yes
                                </label>
                            </div>
                            <div className="form-check form-check-inline">
                                <input
                                    type="radio"
                                    id="have_subsidiary_company_no"
                                    name="have_subsidiary_company"
                                    value="0"
                                    checked={this.state.have_subsidiary_company === "0"}
                                    onChange={() => this.handleChange("have_subsidiary_company","0") }
                                    className="form-check-input"
                                />
                                <label
                                    htmlFor="have_subsidiary_company_no"
                                    className="form-check-label"
                                >
                                    No
                                </label>
                            </div>
                          </div>
                          {this.state.have_subsidiary_company === "1" && (
                            <>
                              {/* subsidiary Legal Entity Name  */}
                              <div className="col-md-4 mb-3">
                                <label htmlFor="subsidiary_legal_entity_name" className="form-label">Subsidiary Legal Entity Name <IsRequired /> :</label>
                                <input
                                  type="text"
                                  id="subsidiary_legal_entity_name"
                                  name="subsidiary_legal_entity_name"
                                  value={this.state.subsidiary_legal_entity_name}
                                  onChange={this.handleInputChange}
                                  className={`form-control ${errors.subsidiary_legal_entity_name ? 'is-invalid' : ''}`}
                                  placeholder="Enter Name"
                                />
                                {errors.subsidiary_legal_entity_name && <div className="invalid-feedback">{errors.subsidiary_legal_entity_name}</div>}
                              </div>
                              {/* subsidiary Company Name */}
                              <div className="col-md-4 mb-3">
                                <label htmlFor="subsidiary_company_name" className="form-label">Subsidiary Company Name <IsRequired /> :</label>
                                <input
                                  type="text"
                                  id="subsidiary_company_name"
                                  name="subsidiary_company_name"
                                  value={this.state.subsidiary_company_name}
                                  onChange={this.handleInputChange}
                                  className={`form-control ${errors.subsidiary_company_name ? 'is-invalid' : ''}`}
                                  placeholder="Enter Name"
                                />
                                {errors.subsidiary_company_name && <div className="invalid-feedback">{errors.subsidiary_company_name}</div>}
                              </div>
                            </>
                          )}
                          {/* Company Address */}
                          {/* <div className="col-md-4 mb-3">
                            <label htmlFor="company_address" className="form-label">Company Address <IsRequired /> :</label>
                            <textarea
                              id="company_address"
                              name="company_address"
                              value={this.state.company_address}
                              onChange={this.handleInputChange}
                              className={`form-control ${errors.company_address ? 'is-invalid' : ''}`}
                              placeholder="Enter Address"
                            />
                            {errors.company_address && <div className="invalid-feedback">{errors.company_address}</div>}
                          </div> */}
                          {/* Register Office Location */}
                          {/* <div className="col-md-4 mb-3">
                            <label htmlFor="register_office_location" className="form-label">Register Office Location:</label>
                            <textarea
                              id="register_office_location"
                              name="register_office_location"
                              value={this.state.register_office_location}
                              onChange={this.handleInputChange}
                              className={`form-control ${errors.register_office_location ? 'is-invalid' : ''}`}
                              placeholder="Enter Register Office Location"
                            />
                            {errors.register_office_location && <div className="invalid-feedback">{errors.register_office_location}</div>}
                          </div> */}
                        {/* </div> */}
                        {/* <div className="row mb-3"> */}
                          
                          {/* Contract Start Date */}
                          {/* <div className="col-md-4 mb-3">
                            <label htmlFor="contract_start_date" className="form-label">Contract Start Date <IsRequired /> :</label>
                            <input
                              type="date"
                              id="contract_start_date"
                              name="contract_start_date"
                              value={this.state.contract_start_date}
                              onChange={this.handleInputChange}
                              className={`form-control ${errors.contract_start_date ? 'is-invalid' : ''}`}
                            />
                            {errors.contract_start_date && <div className="invalid-feedback">{errors.contract_start_date}</div>}
                          </div> */}
                          {/* Contract End Date */}
                          {/* <div className="col-md-4 mb-3">
                            <label htmlFor="contract_end_date" className="form-label">Contract End Date:</label>
                            <input
                              type="date"
                              id="contract_end_date"
                              name="contract_end_date"
                              value={this.state.contract_end_date}
                              onChange={this.handleInputChange}
                              className={`form-control ${errors.contract_end_date ? 'is-invalid' : ''}`}
                            />
                             {errors.contract_end_date && <div className="invalid-feedback">{errors.contract_end_date}</div>} 
                          </div> */}
                        {/* </div> */}
                        {/* <div className="row mb-3"> */}
                          {/* Total Employees */}
                          {/* <div className="col-md-4 mb-3">
                            <label htmlFor="total_employees" className="form-label">Total Employees <IsRequired /> :</label>
                            <input
                              type="number"
                              id="total_employees"
                              name="total_employees"
                              value={this.state.total_employees}
                              onChange={this.handleInputChange}
                              className={`form-control ${errors.total_employees ? 'is-invalid' : ''}`}
                              placeholder="Enter Total Employees"
                            />
                            {errors.total_employees && <div className="invalid-feedback">{errors.total_employees}</div>}
                          </div> */}
                          
                        {/* </div> */}
                        {/* <div className="row mb-3"> */}
                          
                          {/* Twitter Handler */}
                          {/* <div className="col-md-4 mb-3">
                            <label htmlFor="twitter_handler" className="form-label">Twitter Handler:</label>
                            <input
                              type="text"
                              id="twitter_handler"
                              name="twitter_handler"
                              value={this.state.twitter_handler}
                              onChange={this.handleInputChange}
                              className={`form-control ${errors.twitter_handler ? 'is-invalid' : ''}`}
                              placeholder="Enter Twitter Handler"
                            />
                             {errors.twitter_handler && <div className="invalid-feedback">{errors.twitter_handler}</div>}
                          </div> */}
                          {/* <div className="col-md-2" style={{ marginTop: "35px" }}>
                            <label className="form-check-label" style={{ marginRight: "10px" }} for="pt_applicable">PT Applicable : </label>

                            <input
                              type="checkbox"
                              id="pt_applicable"
                              name="pt_applicable"
                              checked={this.state.pt_applicable}
                              onChange={this.handleCheckboxChange}
                              className="form-check-input"
                            />
                          </div>
                          <div className="col-md-2" style={{ marginTop: "35px" }}>
                            <label className="form-check-label" for="lwf_applicable" style={{ marginRight: "10px" }}>LWF Applicable : </label>

                            <input
                              type="checkbox"
                              id="lwf_applicable"
                              name="lwf_applicable"
                              checked={this.state.lwf_applicable}
                              onChange={this.handleCheckboxChange}
                              className="form-check-input"
                            />
                          </div> */}
                          
                        {/* </div> */}
                        
                      </div>
                    </form>
                    <div className="d-flex justify-content-end gap-2">
                      {/* <button type="button" disabled={this.state.postLoading} onClick={this.handleSubmit} className="btn btn-success btn-label waves-effect waves-light">
                        <i className="bx bx-add-to-queue label-icon align-middle fs-16 ms-2" /> Create
                      </button> */}
                      <SubmitButton onClick={(e)=>{ 
                        if(!this.state.postLoading){
                          this.setState({postLoading:true},
                            ()=> this.handleSubmit(e))
                          }  
                        }}
                        // loading={this.state.postLoading}
                        buttonName={this.state.company_id? 'Update Company':'Create Company'} icon={this.state.company_id? ' ri-building-line' : 'ri-building-line'}
                        type={this.state.company_id? 'secondary' : 'primary'} iconSide='left' 
                      />
                      {/* {this.props.company_id && (
                        <NavLink to={"/CompanyList"} ref={this.closeRef} type="button" disabled={this.state.postLoading} onClick={this.resetForm} className="btn btn-danger btn-label waves-effect waves-light" style={{ marginLeft: "10px" }}>
                        <i className="ri-close-fill label-icon align-middle fs-16 " /> Cancel
                      </NavLink>
                      )} */}
                    </div>
                  </div>
                  {this.state.responseModal && (
                    <div id="myModal" className="modal show" tabIndex={-1} style={{
                        display: "block",
                        backgroundColor: "rgba(0, 0, 0, 0.5)",
                        }}
                        aria-labelledby="myModalLabel"
                        aria-hidden="true"
                    >
                        <div
                        className=" bg-light m-auto mt-3"
                        style={{ width: "60%" }}
                        >
                        <div className="modal-content">
                            <div
                            style={{ padding: "10px 10px 0 10px" }}
                            className="modal-header"
                            >
                                <h5 className="modal-title" id="myModalLabel">
                                    Response List 
                                </h5>
                                <button
                                    onClick={() => {
                                        if(!this.state.loadingPost){
                                            this.setState({ responseModal:!this.state.responseModal, responseList:[], })
                                        }
                                    }}
                                    className="btn-close"
                                    aria-label="Close"
                                ></button>
                            </div>
                            <div className="modal-body">
                                <div
                                    style={{ padding: "10px 0px 0 0px" }}
                                    className=" form-steps"
                                >
                                <div className="card-body row gy-4">
                                    <div className="col-md-12">
                                    <div style={{ "maxHeight": "75vh", "overflowY": "auto", "overflowX": "auto" }}>
                                        <table style={{ minwidth: '100%' }} className="table table-borderless table-hover align-middle mb-0 table-bordered table-stripped text-center">
                                          <thead className='bg-primary text-light bg-gradient position-sticky top-0 z-1'>
                                            <tr>
                                              <th>Sr.No.</th>
                                              <th>Response</th>
                                            </tr>
                                          </thead>
                                            <tbody>
                                              {Array.isArray(this.state.responseList) && this.state.responseList?.map((row,idx) => {
                                                return (
                                                  <tr>
                                                    <td>{idx+1}</td>
                                                    <td className={` text-left fw-bolder ${row?.success? "text-success":"text-danger"} `}>{row?.message}</td>
                                                  </tr>
                                                );
                                              })}
                                            </tbody>
                                        </table>
                                      </div>
                                    </div>
                                </div>
                            </div>
                            </div>
                        </div>
                        </div>
                    </div>
                  )}
                {/* </div>
              </div>
            </div> */}
          </div>
      // </div >

    );
  }
}

export default withRouter(CreateCompany);
